import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/products'),
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'PRODUCTS.PAGE_TITLE',
        icon: 'product-icon',
      },
      children: [
        {
          path: '',
          name: 'products',
          component: Index,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
